/** Programme bar row height — matches JupasProgrammeCard (Block 3 Rank). */
export const JUPAS_PROGRAMME_ROW_HEIGHT_PX = 56;

/** Default visible recommendation rows in the programme list / detail panel. */
export const JUPAS_RECOMMENDATION_VISIBLE_ROWS = 10;

/** Visible rows + dividers between them (1px each). */
export const JUPAS_SIX_ROW_LIST_MIN_HEIGHT_PX =
  JUPAS_PROGRAMME_ROW_HEIGHT_PX * JUPAS_RECOMMENDATION_VISIBLE_ROWS
  + (JUPAS_RECOMMENDATION_VISIBLE_ROWS - 1);

export const JUPAS_SIX_ROW_LIST_MIN_HEIGHT_CLASS = 'min-h-0 md:min-h-[569px]';

/** Shared programme bar layout (Block 3 Rank is source of truth). */
export const JUPAS_PROGRAMME_BAR_ROW_CLASS =
  'flex min-h-[48px] w-full min-w-0 select-none items-center gap-1 overflow-hidden px-1 py-1.5 sm:min-h-[56px] sm:gap-3 sm:px-3 sm:py-2';

/** Title + code — must shrink so badges/actions stay visible. */
export const JUPAS_PROGRAMME_BAR_MAIN_CLASS =
  'min-w-0 flex-1 overflow-hidden text-left';

export const JUPAS_PROGRAMME_BAR_IDENTITY_CLASS =
  'flex min-w-0 items-center justify-start gap-1 sm:gap-2.5';

export const JUPAS_PROGRAMME_CODE_LABEL_CLASS =
  'jupas-code-label inline-flex w-12 shrink-0 items-center justify-center overflow-hidden rounded border border-sky-100 bg-sky-50 px-0.5 py-1 text-center text-[9px] font-semibold leading-none text-[#185FA5] dark:border-sky-800/60 dark:bg-sky-950/50 dark:text-sky-300 sm:w-20 sm:rounded-md sm:px-2 sm:py-1.5 sm:text-sm';

export const JUPAS_PROGRAMME_BAR_TITLE_CLASS = 'min-w-0 flex-1 overflow-hidden text-left';

/** P / classification / +− — anchored right; preserve clear separation between labels. */
export const JUPAS_PROGRAMME_BAR_TRAILING_CLASS =
  'ml-auto flex shrink-0 items-center gap-2';

export const JUPAS_PROGRAMME_BAR_ACTION_BUTTON_CLASS =
  'dse-elective-action-button jupas-action-button group inline-flex h-6 w-6 shrink-0 items-center justify-center p-0 disabled:cursor-not-allowed sm:-mx-1.5 sm:h-8 sm:w-8';

export const JUPAS_PROGRAMME_BAR_ACTION_INNER_CLASS =
  'inline-flex h-[18px] w-[18px] items-center justify-center rounded transition-colors sm:h-6 sm:w-6 sm:rounded-md';
